import script from "./UppyUploader.vue?vue&type=script&setup=true&lang=ts"
export * from "./UppyUploader.vue?vue&type=script&setup=true&lang=ts"

import "./UppyUploader.vue?vue&type=style&index=0&id=8ec7068c&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ec7068c"]])

export default __exports__